<template>
  <footer class="footer">
    <div class="footerTop">
      <div class="footerTopLeft">
        <span><img src="@/assets/footerLogo.png" alt="">多洗爱车</span>
        <span>让洗车，足不出户</span>
      </div>
      <div class="footerTopRight">
         <span>联系我们</span>
         <span><img src="@/assets/contact.png" alt="">联系电话：4006681688</span>
      </div>
    </div>
    <div class="footerBottom">
      <span>© 2026 多洗爱车 版权所有</span>
    </div>
  </footer>
</template>

<script>
export default {
  name: "Footer"
};
</script>

<style scoped lang="scss">
.footer {
  width: 100%;
  background: var(--black);
  color: #fff;
  padding: 3vw 4vw 2vw;
  min-height: 130px;
  .footerTop{
    display: flex;
    justify-content: space-around;
    align-items: center;
    padding-bottom: 2vw;
    border-bottom: 0.05vw solid rgba(255,255,255,0.1);
    gap: 4vw;
    .footerTopLeft{
      display: flex;
      flex-direction: column;
      gap: 1.2vw;
      span{
        display: block;
      }
      span:nth-of-type(1){
        font-size: 1.25vw;
        display: flex;
        align-items: center;
        gap: 0.6vw;
        img{
          width: 2.23vw;
          height: 2.23vw;
        }
      }
      span:nth-of-type(2){
        font-size: 0.93vw;
      }
    }
    .footerTopRight{
      display: flex;
      flex-direction: column;
      gap: 2vw;
      span{
        display: block;
      }
      span:nth-of-type(1){
        font-size: 0.93vw;
      }
      span:nth-of-type(2){
        font-size: 0.73vw;
        display: flex;
        align-items: center;
        gap: 0.4vw;
        img{
          width: 1.25vw;
          height: 1.25vw;
        }
      }
    }
  }

  .footerBottom{
    padding-top: 1.5vw;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: #70747D;
    font-size: 0.73vw;
  }
}

// 手机适配 768px 以下
@media (max-width: 768px) {
  .footer {
    padding: 6vw 5vw 4vw;
  }
  .footerTop {
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 6vw 0 10vw 0 !important;
    gap: 10vw !important;
    .footerTopLeft {
      text-align: center;
      gap: 4.2vw !important;
      span:nth-of-type(1) {
        font-size: 5vw !important;
        img {
          width: 8vw !important;
          height: 8vw !important;
        }
      }
      span:nth-of-type(2) {
        font-size: 3.5vw !important;
      }
    }
    .footerTopRight {
      text-align: center;
      margin-top: 1vw;
      gap: 4.2vw !important;
      span:nth-of-type(1) {
        font-size: 3.5vw !important;
      }
      span:nth-of-type(2) {
        font-size: 3.2vw !important;
        img {
          width: 5vw !important;
          height: 5vw !important;
        }
      }
    }
  }
  .footerBottom {
    padding-top: 4vw !important;
    font-size: 3.2vw !important;
  }
}
</style>